import { render, staticRenderFns } from "./ScoreTableModal.vue?vue&type=template&id=02451624&scoped=true"
import script from "./ScoreTableModal.vue?vue&type=script&lang=js"
export * from "./ScoreTableModal.vue?vue&type=script&lang=js"
import style0 from "./ScoreTableModal.vue?vue&type=style&index=0&id=02451624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02451624",
  null
  
)

export default component.exports